<template lang="pug">
  nav.nav
    ul.nav__list
      li.nav__item(v-for="(item, index) in $t('header.menu')", :key='index')
        transition(
          :name="transitionName"
        )
          a.nav__link(
            @click.prevent='onClickLink(item.link, item.href)'
            v-show="menu || nameMenu == 'footer'"
            href="item.href"
          ) {{ item.name }}
        ul.nav__subtitle-list(v-if='item.sub !== null')
          li.nav__subtitle-item(
          v-for='(item, index) in item.sub'
          :key='index'
          )
            transition(
              :name="transitionName"
            )
              a.nav__subtitle-link(
                @click.prevent='onClickLink(item.link, item.href)'
                v-show="menu || nameMenu == 'footer'"
                href="item.href"
              ) {{ item.name }}
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  name: 'Nav',
  props: ['menu', 'transitionName', 'nameMenu'],
  methods: {
    onClickLink (link, href) {
      if (!link) {
        window.open(href, '_blank')
      }
      this.$router.push({ path: link })
      this.$emit('close')
    }
  },
  computed: {
    ...mapGetters({
      'contentHome': 'home/getContent'
    })
  }
}
</script>

<style scoped>
  .transition-enter-active {
    transition: all .5s ease-out;
  }
  .transition-leave-active {
    transition: all .3s ease-out;
  }
  .transition-enter {
    opacity: 0;
    transform: translateY(-100px);
  }
  .transition-leave-to {
    opacity: 0;
    transform: translateY(-100px);
  }
</style>



// WEBPACK FOOTER //
// src/components/Nav/Nav.vue